import React from 'react';

function PlanNoResults() {
  return <div className="u-els-padding-1x">No results found.</div>;
}

export default PlanNoResults;
